import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';
import { GET_DOCUMENTS_BY_IDS } from 'src/hooks/documents/get-documents-by-ids.hook';
import { GET_EMPLOYEE_BY_ID } from 'src/hooks/employees/get-employee-by-id.hook';
import { GET_EMPLOYEE_DOCUMENTS } from 'src/hooks/employees/get-employee-documents.hook';
import { GET_DOCUMENTS_LABELS_BY_COMPANY } from 'src/hooks/documents-labels/get-documents-labels.hook';

export const CREATE_DOCUMENT_TEMPLATE = gql`
  mutation createDocumentTemplate($payload: CreateDocumentTemplateInput!) {
    createDocumentTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useCreateDocumentTemplate = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation(['common', 'settings']);

  const [createDocumentTemplate, { loading }] = useMutation(CREATE_DOCUMENT_TEMPLATE, {
    onCompleted: onSuccess,
    refetchQueries: [
      GET_EMPLOYEE_DOCUMENTS,
      GET_EMPLOYEE_BY_ID,
      GET_DOCUMENTS_BY_IDS,
      GET_DOCUMENTS_LABELS_BY_COMPANY,
    ],
    onError: (error: any) => {
      if (error && error.message) {
        const [errorKey, errorDetail] = error.message.split('-');

        return showNotification({
          type: NOTIFICATION_TYPE.error,
          message: t(`settings:documents.errors.${errorKey}`, { detail: errorDetail }),
        });
      }

      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        ...(error && { description: error.errorMessage }),
      });
    },
  });

  return { createDocumentTemplate, loading };
};
